<template>
  <widget-content
    :config="config"
    variant="leaderboard"
  >
    <div
      v-for="entry in entries"
      v-bind:key="entry.id"
    >
      <hr class="my-1">
      <a
        v-if="entry.link"
        :href="entry.link"
        class="text-body text-decoration-none"
      >
        <leaderboard-entry-content :entry="entry"></leaderboard-entry-content>
      </a>
      <leaderboard-entry-content
        v-else
        :entry="entry"
      ></leaderboard-entry-content>
    </div>
  </widget-content>
</template>

<style scoped>
hr {
  margin-top: 0;
  margin-bottom: 0;
}
</style>

<script>
import { get } from 'lodash'
import LeaderboardEntryContent from './components/LeaderboardEntryContent'
import WidgetContent from './components/WidgetContent'

export default {
  name: 'LeaderboardWidget',

  components: {
    LeaderboardEntryContent,
    WidgetContent
  },

  props: {
    title: {
      type: String,
      default: ''
    },

    config: {
      type: Object,
      required: true
    }
  },

  computed: {
    entries () {
      return get(this.config, 'data.entries') || []
    }
  }
}
</script>